import type { EmployeeCoursesReportFilterI } from 'types';
import { z } from 'zod';

export const employeeCoursesReportFilterSchema = z.object({
  name: z.string().optional(),
  date: z.string().optional(),
  priorityId: z.string().optional(),
  categoryId: z.string().optional(),
  status: z.string().optional(),
  page: z.number().optional(),
  pageSize: z.number().optional(),
});

export const defaultValue: EmployeeCoursesReportFilterI = {
  name: '',
  date: undefined,
  priorityId: undefined,
  categoryId: undefined,
  status: undefined,
};
